import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,  // Fallback to .env variable
});

const loadConfig = async () => {
  try {
    const response = await fetch('/config.json');
    const config = await response.json();
    axiosInstance.defaults.baseURL = config.baseURL || axiosInstance.defaults.baseURL;
    // console.log('Base URL set to:', axiosInstance.defaults.baseURL,",config.baseURL",config.baseURL);
  } catch (error) {
    console.error('Error loading config:', error);
  }
};
// console.log("Axios Base URL:", axiosInstance.defaults.baseURL);

loadConfig();

export default axiosInstance;
